import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-product-eans',
  templateUrl: './product-eans.component.html',
  styleUrls: ['./product-eans.component.css']
})
export class ProductEansComponent implements OnInit {
    prodId;

    public itemsListProductEans: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.prodId = this.stateService.getStateParams()['prod_id'];
    }

    private async loadProductEans() {
        if (!!this.prodId) {
            this.itemsListProductEans = await this.datatask.Post(709, { prod_id: this.prodId });
        }
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'productean':
                this.stateService?.go('productean', {
                    prod_id: this.prodId,
                    productean_keyno: '0'
                });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadProductEans();
    }

    ngOnInit() {
        this.init();
    }
}
